import { render } from "./MintSpeedBenchmark.vue?vue&type=template&id=0df45b74"
import script from "./MintSpeedBenchmark.vue?vue&type=script&lang=js"
export * from "./MintSpeedBenchmark.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__